import toast from 'react-hot-toast'
import api from './api'

export const dataAccessService = {
    async getAllDataAccess(data) {
        try {
            const response = await api.post('/access/get-datasets', data)
            return response
        } catch (e) {
            toast.error(e.response.data.message || 'failed to fetch data')
        }
    },
    async getDataAccessById(data) {
        try {
            const response = await api.post('/access/get-report-type', data)
            return response
        } catch (e) {
            toast.error(e.response.data.message || 'failed to fetch data')
        }
    },
    async getDataSetTypeForFilter() {
        try {
            const response = await api.post('/access/get-data-sets')
            return response
        } catch (e) {
            toast.error(e.response.data.message || 'failed to fetch data')
        }
    },
    async getAccessLevel() {
        try {
            const response = await api.post('/access/get-access-level')
            return response
        } catch (e) {
            toast.error(e.response.data.message || 'failed to fetch data')
        }
    },
      async updateDataAccess(params) {
        try {
            const response = await api.post('/access/update-access-level',params)
      toast.success(response.message );

            return response
        } catch (e) {
            toast.error(e.response.data.message || 'failed to fetch data')
        }
    },
}